/* Guide product CTA — gallery with prev/next arrows and a thumbnail strip
   that follows the selection (matches the PDP gallery behavior). Scoped to
   the element so several instances and Theme Editor re-renders both work.
   Click-only; no autoplay. */

class GuideProductGallery extends HTMLElement {
  connectedCallback() {
    this.images = Array.from(this.querySelectorAll('.guide-pcta__image'));
    this.thumbs = Array.from(this.querySelectorAll('.guide-pcta__thumb'));
    if (!this.images.length) return;
    this.index = 0;
    this.go(0, false);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const arrow = event.target.closest('.guide-pcta__arrow');
    if (arrow && this.contains(arrow)) {
      const step = arrow.classList.contains('guide-pcta__arrow--next') ? 1 : -1;
      this.go((this.index + step + this.images.length) % this.images.length, true);
      return;
    }
    const thumb = event.target.closest('.guide-pcta__thumb');
    if (thumb && this.contains(thumb)) this.go(this.thumbs.indexOf(thumb), true);
  };

  go(index, followThumb) {
    if (index < 0) return;
    this.index = index;
    this.images.forEach((el, i) => el.classList.toggle('is-active', i === index));
    this.thumbs.forEach((el, i) => el.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    // Rotate the thumb strip so the active thumb is always in view.
    const active = this.thumbs[index];
    if (active && followThumb) {
      active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }
}

if (!customElements.get('guide-product-gallery')) {
  customElements.define('guide-product-gallery', GuideProductGallery);
}
